import CityPageTemplate from "../city-template/CityPageTemplate";
import { lexingtonParkConfig } from "./data";

export default function LexingtonParkPage() {
  return <CityPageTemplate config={lexingtonParkConfig} />;
}